module.exports = __webpack_public_path__ + "static/image 5-2280746f7e9208bb982c7f48bc397552.png";